module.exports = __webpack_public_path__ + "static/media/pic3.1d343f09.jpg";